// extracted by mini-css-extract-plugin
export default {"toggle":"Toggle_toggle__cm9EO","track":"Toggle_track__P3Wmn","thumb":"Toggle_thumb__2L3oJ","input":"Toggle_input__S91tg"};